export function saveBlob(blob, fileName) {
  const a = document.createElement('a');
  a.href = window.URL.createObjectURL(blob);
  a.download = fileName;
  a.click();
  a.remove();
}
